import collectTimes from "@/components/garbage/collectTimes";
import bucket from "@/components/garbage/bucket";
import landmark from "@/components/garbage/landmark";
import siteCollect from "@/components/garbage/siteCollect";
import siteTransfer from "@/components/garbage/siteTransfer";
import ljqyzl from "@/components/garbage/ljqyzl";
import ljqycx from "@/components/garbage/ljqycx";
import lajiqingyun from "@/components/garbage/zyxl";


var data = [
  {
    path: "/collectTimes",
    component: collectTimes
  },
  {
    path: "/bucket",
    component: bucket
  },
  {
    path: "/landmark",
    component: landmark
  },
  {
    path: "/siteCollect",
    component: siteCollect
  },
  {
    path: "/siteTransfer",
    component: siteTransfer
  },
  {
    path: "/ljqyzl",
    component: ljqyzl
  },{
    path: "/lajiqingyun",
    component: lajiqingyun
  },
  {
    path: "/ljqycx",
    component: ljqycx
  }
];
export default data;



// WEBPACK FOOTER //
// ./src/router/qingyun.js